import CollectionItem from './CollectionItem'

export default CollectionItem
